<button
    mat-flat-button
    class="dxc-purple clock-section-button"
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger"
    (mouseenter)="openMenu()"
    (mouseleave)="closeMenu()"
    (click)="openClockDialog()"
    [disabled]="isLoading"
>
    <div *ngIf="isLoading">
        <div class="clock-section-button-spinner">
            <mat-spinner [diameter]="21"></mat-spinner>
        </div>
    </div>
    <div *ngIf="!isLoading">
        <mat-icon
            svgIcon="hub_globe"
            class="clock-section-button-icon"
        >
        </mat-icon>
        {{today$ | async | date: clockSettingsDocument.worldclock.timeFormat : (clockSettingsDocument.worldclock.current ? getTimezoneOffset(clockSettingsDocument.worldclock.current.timezone) : '')}}
        <mat-icon
            svgIcon="hub_poi_filled"
            class="clock-section-button-icon current-city-icon"
        >
        </mat-icon>
        <span class="current-city-name">
            {{clockSettingsDocument.worldclock.current ? clockSettingsDocument.worldclock.current.city : consts.LOCATION_LOCAL}}
        </span>
    </div>
    <div class="clock-section-button-settings-overlay">
        <mat-icon
            svgIcon="hub_settings"
            class="clock-section-button-settings-overlay-icon"
        >
        </mat-icon>
    </div>
</button>
<mat-menu
    #menu="matMenu"
    class="clock-section-favorites-menu"
    xPosition="before"
    yPosition="below"
    [hasBackdrop]="false"
>
    <div
        (mouseenter)="openMenu()"
        (mouseleave)="closeMenu()"
        class="mat-menu-list"
    >
        <button
            *ngIf="clockSettingsDocument.worldclock.current"
            mat-menu-item
            class="clock-section-local-location"
            (click)="changeCurrentClock(-1)"
        >
            <div class="row">
                <div class="col-6">
                    <div class="row">
                        <div class="col-3 dxc-purple clock-section-local-location-icon-container">
                            <mat-icon
                                class="clock-section-local-icon"
                                svgIcon="hub_globe"
                            >
                            </mat-icon>
                        </div>
                        <div class="col-9">
                            <p class="mb-0 clock-section-local-city-text">
                                {{consts.LABEL_LOCAL_TIME}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-6 text-right">
                    <p class="mb-0 clock-section-local-time-text">
                        {{today$ | async | date: clockSettingsDocument.worldclock.timeFormat}}
                    </p>
                    <p class="clock-section-local-date-text">
                        {{today$ | async | date: (clockSettingsDocument.worldclock.showDayOfWeek ? consts.DAYOFWEEK_FORMAT : '') + clockSettingsDocument.worldclock.dateFormat}}
                    </p>
                </div>
            </div>
        </button>
        <div *ngFor="let favorite of menuList.favorites; index as i">
            <button
                *ngIf="getLocationIndexInList(menuList.favorites, clockSettingsDocument.worldclock.current) !== i"
                mat-menu-item
                class="clock-section-favorites-location"
                (click)="changeCurrentClock(i)"
            >
                <div class="row">
                    <div class="col-6">
                        <div class="row">
                            <div class="col-3 dxc-purple clock-section-favorites-location-icon-container">
                                <mat-icon
                                    class="clock-section-favorites-icon"
                                    svgIcon="hub_star_filled"
                                >
                                </mat-icon>
                            </div>
                            <div class="col-9">
                                <p class="mb-0 clock-section-favorites-city-text">
                                    {{favorite.city}}
                                </p>
                                <p class="clock-section-favorites-country-text">
                                    {{(favorite.province ? favorite.province + ', ' : '') + favorite.country}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-right">
                        <p class="mb-0 clock-section-favorites-time-text">
                            {{today$ | async | date: clockSettingsDocument.worldclock.timeFormat : getTimezoneOffset(favorite.timezone)}}
                        </p>
                        <p class="clock-section-favorites-date-text">
                            {{today$ | async | date: (clockSettingsDocument.worldclock.showDayOfWeek ? consts.DAYOFWEEK_FORMAT : '') + clockSettingsDocument.worldclock.dateFormat : getTimezoneOffset(favorite.timezone)}}
                        </p>
                    </div>
                </div>
            </button>
        </div>
        <!-- TH-2127-Time-Zone-list-expand, remove recent list from pane -->
        <!-- <div *ngFor="let recent of menuList.recents; index as i">
            <button
                *ngIf="getLocationIndexInList(menuList.recents, clockSettingsDocument.worldclock.current) !== i"
                mat-menu-item
                class="clock-section-recents-location"
                (click)="changeCurrentClock(i + menuList.favorites.length)"
            >
                <div class="row">
                    <div class="col-6">
                        <div class="row">
                            <div class="col-3 dxc-purple clock-section-recents-location-icon-container">
                                <mat-icon
                                    class="clock-section-recents-icon"
                                    svgIcon="hub_clock"
                                >
                                </mat-icon>
                            </div>
                            <div class="col-9">
                                <p class="mb-0 clock-section-recents-city-text">
                                    {{recent.city}}
                                </p>
                                <p class="clock-section-recents-country-text">
                                    {{(recent.province ? recent.province + ', ' : '') + recent.country}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-right">
                        <p class="mb-0 clock-section-recents-time-text">
                            {{today$ | async | date: clockSettingsDocument.worldclock.timeFormat : getTimezoneOffset(recent.timezone)}}
                        </p>
                        <p class="clock-section-recents-date-text">
                            {{today$ | async | date: (clockSettingsDocument.worldclock.showDayOfWeek ? consts.DAYOFWEEK_FORMAT : '') + clockSettingsDocument.worldclock.dateFormat : getTimezoneOffset(recent.timezone)}}
                        </p>
                    </div>
                </div>
            </button>
        </div> -->
    </div>
</mat-menu>
